/* sucrase/dist/esm/NameManager.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    const tslib_1 = require("tslib");
    const getIdentifierNames_1 = tslib_1.__importDefault(require("981a8f5cdf") /* ./util/getIdentifierNames */);
    class NameManager {
        __init() { this.usedNames = new Set(); }
        constructor(code, tokens) {
            ;
            NameManager.prototype.__init.call(this);
            this.usedNames = new Set((0, getIdentifierNames_1.default)(code, tokens));
        }
        claimFreeName(name) {
            const newName = this.findFreeName(name);
            this.usedNames.add(newName);
            return newName;
        }
        findFreeName(name) {
            if (!this.usedNames.has(name)) {
                return name;
            }
            let suffixNum = 2;
            while (this.usedNames.has(name + String(suffixNum))) {
                suffixNum++;
            }
            return name + String(suffixNum);
        }
    }
    exports.default = NameManager;
}
